
<portal to="fullscreen" v-if="show">
  <div
    class="fullscreen-image backdrop"
    @click="$emit('hide')"
  >
    <div class="image-container">
      <img :src="image" :alt="label" />
    </div>

    <div class="actions-container">
      <btn
        v-if="hasBackImage"
        kind="flat"
        icon="360"
        @click.stop.prevent="$emit('flip')">
        Flip card
      </btn>
    </div>
  </div>
</portal>
